import Constants from 'expo-constants';

export const apiUrl = {
  dev: 'http://localhost:3001',
  staging: 'https://api.cpluspromo3.staging.zap.com.ph',
  preprod: 'https://api.cpluspromo3.preprod.zap.com.ph',
  prod: 'https://api.customerplus-ht2026.zap.com.ph',
};

const aboutUrl = {
  dev: 'https://about.cpluspromo3.zap.com.ph',
  staging: 'https://about.cpluspromo3.zap.com.ph',
  preprod: 'https://about.cpluspromo3.zap.com.ph',
  prod: 'https://about.customerplus-ht2026.zap.com.ph',
};

export const getApiUrl = (zenv = Constants.manifest.releaseChannel) => {
  if (__DEV__) return apiUrl.dev;
  if (zenv === 'staging') return apiUrl.staging;
  if (zenv === 'preprod') return apiUrl.preprod;
  if (zenv === 'prod') return apiUrl.prod;
};

export const getAboutUrl = (zenv = Constants.manifest.releaseChannel) => {
  if (__DEV__) return aboutUrl.dev;
  if (zenv === 'staging') return aboutUrl.staging;
  if (zenv === 'preprod') return aboutUrl.preprod;
  if (zenv === 'prod') return aboutUrl.prod;
};
